export default {
  name: 'marking--docCheckStatus',
};
